module.exports = __webpack_public_path__ + "img/BlinkArt_Sword3_Red.3cf6b9c9.png";